define([
        'jquery',
        'js/widget-utils'
    ],
    function ($, WidgetUtils) {
        
        const namespace = 'munro_findInStoreApi';

        return class FindInStoreApi {
            constructor (options) {
                this.options = Object.assign({
                                                timeoutMs: 500,
                                                getStockApiUrl: '/api/get-stock',
                                                getLocationsApiUrl: '/stockists/index/search'
                                             },
                                             options,
                                             WidgetUtils.optionsFromQueryString(namespace));
            }

            getLocations (payload) {
                return new Promise((resolve, reject) => {
                    $.ajax({
                        url: this.options.getLocationsApiUrl,
                        type: 'GET',
                        data: payload,
                        error: (response, status, error) => {
                            reject({response, status, error});
                        },
                        success:  (data, status, response) => {
                            resolve({response, status, data});
                        }
                    });
    
                })
            }

            getStock ({store_id, product_id}) {
                return new Promise((resolve, reject) => {
                    $.ajax({
                        url: this.options.getStockApiUrl,
                        cache: false,
                        type: 'GET',
                        data: {store_id, product_id},
                        error: (response, status, error) => {
                            reject({response, status, error});
                        },
                        success:  (data, status, response) => {
                            resolve({response, status, data});
                        }
                    });
    
                })
            }
        }
    });
